import { render, staticRenderFns } from "./Greetings.vue?vue&type=template&id=2145d7c4&scoped=true&"
import script from "./Greetings.vue?vue&type=script&lang=js&"
export * from "./Greetings.vue?vue&type=script&lang=js&"
import style0 from "./Greetings.vue?vue&type=style&index=0&id=2145d7c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2145d7c4",
  null
  
)

export default component.exports